var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldLampSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 13.65c-.47.47-1.29.37-1.59-.23-.54-1.07-.84-2.24-.84-3.37 0-2.45 1.09-4.74 3-6.28s4.41-2.11 6.86-1.57c.54.12 1.07.29 1.57.52.64.29.8 1.13.3 1.63l-9.3 9.3zM8.55 20.628c-.37.11-.59.49-.48.86.11.37.49.58.86.48 2.01-.57 4.12-.57 6.13 0 .06.02.13.03.19.03.3 0 .58-.2.67-.51.11-.37-.1-.75-.47-.86-2.26-.64-4.64-.64-6.9 0zM19.5 1.952 3.65 17.802c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2.46-2.46c.22.18.45.36.69.52v.83c-.01.28-.02.71.31 1.06.35.35.87.4 1.28.4h5.13c.54 0 .95-.15 1.23-.43.39-.4.37-.9.36-1.16v-.7c3.11-2.09 5.06-6.5 3.04-10.56-.22-.43-.49-.84-.79-1.22l2.13-2.13c.3-.29.3-.77.01-1.06a.754.754 0 0 0-1.06 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLampSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-lamp-slash.426a286db933e4d977840a26fd9e3e09.svg";
export { ForwardRef as ReactComponent };